import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import "../../assets/styles/local/StockAssigneeModal.css";
import Header from "../../layouts/Header";
import AddTaskModal from "../../components/Dailogs/AddTaskModal";
import loading from "../../assets/icons/loading.gif";
import warning from "../../assets/icons/warning.png";
import crossIcon from "../../assets/icons/x-circle.svg";
import searchIcon from "../../assets/icons/searchicon.svg";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import AssigneeModal from "../../components/TaskFilter/AssigneeModal";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { FetchActiveUsersList } from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";

const StockAssignee = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;

  const [assigneeData, setAssigneeData] = useState([]);
  const [workerData, setWorkerData] = useState([]);
  const [teamsData, setTeamsData] = useState([]);
  // const [selectedData, setSelectedData] = useState([]);
  const [selectedData, setSelectedData] = useState([
    ...props.sendingData.map((x) => ({
      firstname: x.firstName,
      asc_Worker_ID: x.type === "single" && x.id,
      asc_Team_ID: x.type === "Teams" && x.teamID,
      asc_Type: x.type,
    })),
  ]);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Stock Overview").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const [assigneeSearch, setAssigneeSearch] = useState("");
  const [workerTab, setWorkerTab] = useState(true);
  const [teamsTab, setTeamsTab] = useState(false);
  const [assigneeModalOpen, setAssigneeModalOpen] = useState(false);

  const companyId = window.localStorage.getItem("companyid");

  const fetchAssigneeResponse = useSelector(
    (state) => state.user.fetchAssigneeResponse
  );

  useEffect(() => {
    dispatch(FetchActiveUsersList(companyId));
  }, []);

  useEffect(() => {
    if (fetchAssigneeResponse.status === true) {
      setAssigneeData(fetchAssigneeResponse?.data);
    }

    setWorkerData(
      fetchAssigneeResponse?.data?.filter((item) => item.type === "user")
    );

    setTeamsData(
      fetchAssigneeResponse?.data?.filter((item) => item.type === "team")
    );
  }, [fetchAssigneeResponse]);

  return (
    <div
      className="assigneeModal"
      style={{
        position: "absolute",
        top: "35px",
        zIndex: "33",
        left: "0px",
        // 👇 Parent ka style yaha hoga
        ...props.style,
      }}
    >
      <div className="d-flex gap-3 p-3" style={{ background: "#f1f1f1" }}>
        <div className="d-flex gap-1 tabsDiv">
          <p
            className={workerTab ? "tabHighlight" : "tabNormal"}
            style={{ display: props.showWorkersTab ? "block" : "none" }}
            onClick={() => {
              setWorkerTab(true);
              setTeamsTab(false);
            }}
          >
            {/* Workers */}
            {t("Workers")}
          </p>

          <p
            className={teamsTab ? "tabHighlight" : "tabNormal"}
            style={{ display: props.showTeamsTab ? "block" : "none" }}
            onClick={() => {
              setTeamsTab(true);
              setWorkerTab(false);
            }}
          >
            {/* Teams */}
            {t("Teams")}
          </p>
        </div>

        <input
          type="text"
          className="ps-2 assigneeSearch ms-auto"
          value={assigneeSearch}
          // placeholder="Search"
          placeholder={t("Search")}
          onChange={(e) => {
            setAssigneeSearch(e.target.value);
          }}
        />

        <img
          src={crossIcon}
          alt=""
          className="pointer ms-auto pe-3"
          onClick={() => {
            props.closeAssigneeModal(false);
          }}
        />
      </div>

      {/* worker Tab start */}
      {workerTab && (
        <div
          className="workerTabDiv"
          id="ascSelectBox" // for custom scroll bar.
        >
          {workerData
            ?.filter(
              (item) =>
                item.firstname
                  ?.toLowerCase()
                  .includes(assigneeSearch.toLowerCase()) ||
                item.firstname
                  ?.toLowerCase()
                  .includes(assigneeSearch.toLowerCase())
            )
            .map((item) => {
              return (
                <div
                  className="d-flex align-items-center gap-4 p-1 animate__animated animate__fadeInLeft"
                  style={{ borderBottom: "1px dotted grey" }}
                  onClick={(e) => {
                    let index2 = selectedData.findIndex(
                      (selected) => selected?.asc_Worker_ID === item.userid
                    );

                    if (index2 !== -1) {
                      let data = [...selectedData];
                      data.splice(index2, 1);
                      setSelectedData(data);
                      // return;

                      // send data to parent component👇.
                      props.removeUsersData(
                        {
                          firstName: item.firstname,
                          lastName: item.lastname,
                          imageurl: item.imageurl,
                          jobtypename: item.jobtypename,
                          id: item.userid,
                          type: "single",
                        },
                        "single"
                      );
                      return;
                    }

                    // start item pushing...
                    let invoiceListArray = [...selectedData];
                    invoiceListArray.push({
                      asc_Worker_Name: item.firstname,
                      asc_Worker_ID: item.userid,
                      asc_Type: "single",
                    });
                    setSelectedData(invoiceListArray);

                    // send data to parent component👇.
                    props.addUsersData(
                      {
                        firstName: item.firstname,
                        lastName: item.lastname,
                        imageurl: item.imageurl,
                        jobtypename: item.jobtypename,
                        id: item.userid,
                        // maxAmount: props.headerMaxAmount,
                        type: "single",
                      },
                      "single"
                    );
                    // props.setHeaderMaxAmount("");
                  }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input pointer companyRadio ps-2"
                    //   value={}
                    // placeholder="Search"
                    placeholder={t("Search")}
                    checked={
                      !!selectedData.find(
                        (selected) => selected?.asc_Worker_ID === item.userid
                      )
                    }
                    onClick={(e) => {
                      if (e.target.checked) {
                        props.addUsersData(
                          {
                            firstName: item.firstname,
                            lastName: item.lastname,
                            imageurl: item.imageurl,
                            jobtypename: item.jobtypename,
                            id: item.userid,
                            type: "single",
                          },
                          "single"
                        );
                      }

                      if (!e.target.checked) {
                        props.removeUsersData(
                          {
                            firstName: item.firstname,
                            lastName: item.lastname,
                            imageurl: item.imageurl,
                            jobtypename: item.jobtypename,
                            id: item.userid,
                            type: "single",
                          },
                          "single"
                        );
                      }
                    }}
                  />

                  <div className="">
                    {item.imageurl ? (
                      <img
                        src={item.imageurl}
                        alt=""
                        className="assigneeIMG"
                        onError={(e) => {
                          // e.target.src = "img url";
                          e.target.src = warning;
                        }}
                      />
                    ) : (
                      <div className="assigneeAbbr">
                        {item.lastname
                          ? item?.firstname[0] + "" + item?.lastname[0]
                          : item?.firstname?.slice(0, 2)}
                      </div>
                    )}
                  </div>

                  <p className="mb-0" style={{ width: "150px" }}>
                    {item.firstname} &nbsp; {item.lastname}
                  </p>

                  <p className="mb-0"> ┃ </p>

                  <p className="mb-0">{item.jobtypename}</p>
                </div>
              );
            })}
        </div>
      )}

      {/* Teams Tab start */}
      {teamsTab && (
        <div
          className="workerTabDiv"
          id="ascSelectBox" // for custom scroll bar.
        >
          {teamsData
            ?.filter((item) =>
              // item.firstname
              //   ?.toLowerCase()
              //   .includes(assigneeSearch.toLowerCase()) ||
              // item.firstname
              //   ?.toLowerCase()
              //   .includes(assigneeSearch.toLowerCase())
              `${item?.firstname} ${item?.lastname}`
                .toLocaleLowerCase()
                .includes(assigneeSearch.toLowerCase())
            )
            .map((item) => {
              return (
                <div
                  className="d-flex align-items-center gap-4 p-1 animate__animated animate__fadeInLeft"
                  style={{ borderBottom: "1px dotted grey" }}
                  onClick={() => {
                    let index2 = selectedData.findIndex(
                      (selected) => selected?.asc_Team_ID === item.userid
                    );

                    if (index2 !== -1) {
                      let data = [...selectedData];
                      data.splice(index2, 1);
                      setSelectedData(data);
                      // return;

                      // send data to parent component👇.
                      // props.removeUsersData(
                      //   item.teammember.map((x) => ({
                      //     firstName: x.firstname,
                      //     lastName: x.lastname,
                      //     imageurl: x.imageurl,
                      //     id: x.userid,
                      //     type: "Teams",
                      //   }))
                      // );
                      props.removeUsersData(
                        {
                          firstName: item.firstname,
                          lastName: item.lastname,
                          imageurl: item.imageurl,
                          teamID: item.userid,
                          type: "Teams",
                        },
                        "Teams"
                      );
                      return;
                    }

                    // start item pushing...
                    let invoiceListArray = [...selectedData];
                    invoiceListArray.push({
                      asc_Team_Name: item.firstname,
                      asc_Team_ID: item.userid,
                      asc_Type: "Teams",
                    });
                    setSelectedData(invoiceListArray);

                    // send data to parent component👇.
                    // props.addUsersData(
                    //   item.teammember.map((x) => ({
                    //     firstName: x.firstname,
                    //     lastName: x.lastname,
                    //     imageurl: x.imageurl,
                    //     id: x.userid,
                    //     type: "Teams",
                    //     teamID: item.userid,
                    //   }))
                    // );
                    props.addUsersData(
                      {
                        firstName: item.firstname,
                        lastName: item.lastname,
                        imageurl: item.imageurl,
                        teamID: item.userid,
                        type: "Teams",
                      },
                      "Teams"
                    );
                  }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input pointer companyRadio ps-2"
                    //  value={}
                    // placeholder="Search"
                    placeholder={t("Search")}
                    checked={
                      !!selectedData.find(
                        (selected) => selected?.asc_Team_ID === item.userid
                      )
                    }
                    onClick={(e) => {
                      if (e.target.checked) {
                        // props.addUsersData(
                        //   item.teammember.map((x) => ({
                        //     firstName: x.firstname,
                        //     lastName: x.lastname,
                        //     imageurl: x.imageurl,
                        //     id: x.userid,
                        //     type: "Teams",
                        //     teamID: item.userid,
                        //   }))
                        // );

                        props.addUsersData(
                          {
                            firstName: item.firstname,
                            lastName: item.lastname,
                            imageurl: item.imageurl,
                            teamID: item.userid,
                            type: "Teams",
                          },
                          "Teams"
                        );
                      }

                      if (!e.target.checked) {
                        // props.removeUsersData(
                        //   item.teammember.map((x) => ({
                        //     firstName: x.firstname,
                        //     lastName: x.lastname,
                        //     imageurl: x.imageurl,
                        //     id: x.userid,
                        //     type: "Teams",
                        //   }))
                        // );

                        props.removeUsersData(
                          {
                            firstName: item.firstname,
                            lastName: item.lastname,
                            imageurl: item.imageurl,
                            teamID: item.userid,
                            type: "Teams",
                          },
                          "Teams"
                        );
                      }
                    }}
                  />

                  <div className="">
                    {item.imageurl ? (
                      <img src={item.imageurl} alt="" className="assigneeIMG" />
                    ) : (
                      <div className="assigneeAbbr">
                        {item.lastname
                          ? item?.firstname[0] + "" + item?.lastname[0]
                          : item?.firstname?.slice(0, 2)}
                      </div>
                    )}
                  </div>

                  <p className="mb-0" style={{ width: "150px" }}>
                    {item.firstname} &nbsp; {item.lasttname}
                  </p>

                  <p className="mb-0"> ┃ </p>

                  <p className="mb-0">{`${item.teammembercount} Members`}</p>
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
};

export default StockAssignee;
